var map = {
	"./about.mp4": "ae81",
	"./aboutMob.mp4": "0f74",
	"./argendata.mp4": "2759",
	"./coronaTransport.mp4": "d94d",
	"./especial2020.mp4": "1d51",
	"./gameTronos.mp4": "3fa0",
	"./ipars.mp4": "012e",
	"./jjooJuventud.mp4": "1c96",
	"./luna50alu.mp4": "b381",
	"./maradonaFrases.mp4": "056b",
	"./mejorGol.mp4": "321a",
	"./misetIllus.mp4": "bf64",
	"./paso2019.mp4": "b832",
	"./subAraResumen.mp4": "d5f1",
	"./tronos2019.mp4": "4514",
	"./virusColectivo.mp4": "4966"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1414";